import { IHttpRequest, IHttpMapGet } from '../interfaces/httpReq.interface';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '@ebw-monorepo/login';

@Injectable({
  providedIn: 'root'
})
export class MapRequestService {
  httpHeader: HttpHeaders;

  constructor(private httpClient: HttpClient) {}

  getMapRequest(req: IHttpMapGet): Observable<Object> {
    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY)
    });

    if (req.user_id) {
      headers = headers.append('User', req.user_id);
    }

    let opts = {
      headers: headers
    };

    return this.httpClient.get(req.url, opts);
  }

  postMapRequest(req: IHttpRequest, body: Object = {}, options?): Observable<Object> {
    let opts = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY)
      })
    };
    if (options) {
      Object.assign(opts, options);
    }

    return this.httpClient.post(req.url, body, opts);
  }
}
